import script from "./JsonViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./JsonViewer.vue?vue&type=script&setup=true&lang=js"

import "./JsonViewer.vue?vue&type=style&index=0&id=1d406bc8&scoped=true&lang=css"
script.__scopeId = "data-v-1d406bc8"

export default script